<template>
  <m-card920 :image="content.thumbnail" :alt="content.title">

    <template #p-1>
      <div class=""></div>
    </template>

    <template #p-2>
      <m-a :href="findLinkOnContent(content.abstraction)">
        <m-h5 class="text-dark">{{ content.title }}</m-h5>
      </m-a>
    </template>

    <template #p-3>

      <div class="">
        <m-a :href="findLinkOnContent(content.abstraction)">
          <button class="border-0 text-dark font-weight-bold btn-sm btn">
            <span class="pl-1" v-t="`post.card.more`"></span>
            <m-icon icon="arrow-left"/>
          </button>
        </m-a>
      </div>
    </template>

  </m-card920>
</template>

<script>
import mCard920 from '../../Cards/Card920.vue'
import mIcon from "../../Icons/Icon.vue";
import mA from "../../Tags/A.vue";
import mH5 from "../../Tags/H5.vue";
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";

export default {
  name: "ContentCard919",
  methods: {contentSlicer},
  props: {
    content: {}
  },
  components: {mH5, mA, mIcon, mCard920},

}
</script>

<style scoped>
.post-card-921 {
  font-size: 18px;
}
</style>